import { Button } from "@/packages/common/src/components/ui/Button";
import { cn } from "@/packages/common/src/lib/utils";
import type { SecurityUpdate } from "@/src/lib/data/securityUpdates";
import { Heading } from "@common/components/ui/Heading";
import type React from "react";
import { useState } from "react";

interface SecurityUpdateCardProps {
  update: SecurityUpdate;
  className?: string;
}

export const SecurityUpdateCard: React.FC<SecurityUpdateCardProps> = ({ update, className = "" }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div className={cn("", className)}>
      <div className="flex">
        <Heading
          subText={undefined}
          subHeading={
            <div className="flex items-baseline self-center">
              <div className="border border-border rounded-full px-1 bg-faintBlue text-secondary-dark font-normal text-sm text-left leading-normal min-w-fit">
                {update.category}
              </div>
            </div>
          }
          subtextVariant={"secondary"}
        >
          {update.title}
        </Heading>
        <div className="flex-1">
          <div className="text-xs md:text-md flex items-center justify-end text-secondary-dark">{update.date}</div>
        </div>
      </div>

      <div className="relative">
        <div
          className={cn(
            "overflow-hidden transition-all [&_a]:text-purple [&_a]:hover:text-darkPurple [&_a]:font-medium",
            !isExpanded ? "max-h-[150px]" : undefined
          )}
          dangerouslySetInnerHTML={{ __html: update.description }}
        />
        <div
          className={cn(
            "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-white via-white/70 to-transparent pt-8",
            isExpanded ? "relative p-0 bg-transparent bg-gradient-to-t from-transparent to-transparent via-transparent" : undefined
          )}
        >
          <Button
            widthVariant={"full"}
            variant={"ghost"}
            size={!isExpanded ? "default" : "tight"}
            onClick={() => setIsExpanded(!isExpanded)}
            className={cn("text-primary-600 hover:text-primary-700 font-medium", isExpanded ? "text-md" : undefined)}
          >
            {!isExpanded ? (
              <div className="flex items-center justify-center">Read more</div>
            ) : (
              <div className="flex items-center justify-center">Show less</div>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};
